import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import JoditEditor from "jodit-react";
import Adminnavbar from "../Adminnavbar";

export default function CreateJob() {
    const editor = useRef(null);
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [job, setJob] = useState({
        title: "",
        category: "",
        time: "",
        experience: "",
        department: "",
        description: "",
    });

    // ================= HANDLE INPUT =================
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setJob((prev) => ({ ...prev, [name]: value }));
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        const {
            title,
            category,
            time,
            experience,
            department,
            description,
        } = job;

        // VALIDATION
        if (
            !title ||
            !category ||
            !time ||
            !experience ||
            !department ||
            !description
        ) {
            Swal.fire({
                title: "All fields are required",
                icon: "warning",
            });
            return;
        }

        try {
            setLoader(true);

            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/job/store`,
                job
            );

            if (res.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Job Created Successfully",
                    timer: 1500,
                }).then(() => navigate("/job-list"));
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Something went wrong!",
                icon: "error",
            });
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            <Adminnavbar />

            {loader ? (
                <div className="text-center mt-5">Loading...</div>
            ) : (
                <div className="page-wrapper">
                    <div className="content">
                        <form onSubmit={handleSubmit}>
                            <nav
                                aria-label="breadcrumb"
                                style={{ "--bs-breadcrumb-divider": "none" }}
                            >
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/admindashbord">Dashboard</Link> /
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/job-list">Jobs</Link> /
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Add Job
                                    </li>
                                </ol>
                            </nav>

                            <div className="content-page-header">
                                <h5>Add Job</h5>
                            </div>

                            <div className="row">
                                {/* Title */}
                                <div className="col-lg-4">
                                    <label>Job Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        value={job.title}
                                        onChange={handleInputChange}
                                    />
                                </div>


                                {/* Category */}
                                <div className="col-lg-4">
                                    <label>Category</label>
                                    <select
                                        name="category"
                                        className="form-control"
                                        value={job.category}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Article Assistant">Article Assistant</option>
                                        <option value="Qualified CA">Qualified CA</option>
                                        <option value="Semi-qualified">Semi-qualified</option>
                                        <option value="Support Roles">Support Roles</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>

                                <div className="col-lg-4">
                                    <label>Job Type</label>
                                    <select
                                        name="time"
                                        className="form-control"
                                        value={job.time}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Full Time">Full Time</option>
                                        <option value="Part Time">Part Time</option>
                                        <option value="Internship">Internship</option>
                                    </select>
                                </div>

                                {/* Experience */}
                                <div className="col-lg-4 mt-3">
                                    <label>Experience</label>
                                    <input
                                        type="text"
                                        name="experience"
                                        className="form-control"
                                        placeholder="e.g. 1-3 Years"
                                        value={job.experience}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* Department */}
                                <div className="col-lg-4 mt-3">
                                    <label>Department</label>
                                    <input
                                        type="text"
                                        name="department"
                                        className="form-control"
                                        value={job.department}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* Description (Jodit) */}
                                <div className="col-lg-12 mt-3">
                                    <label>Description</label>
                                    <JoditEditor
                                        ref={editor}
                                        value={job.description}
                                        onChange={(newContent) =>
                                            setJob((prev) => ({
                                                ...prev,
                                                description: newContent,
                                            }))
                                        }
                                    />
                                </div>

                                {/* Buttons */}
                                <div className="col-lg-12 mt-4">
                                    <div className="btn-path">
                                        <Link to={"/job-list"} className="btn btn-cancel me-3">
                                            Back
                                        </Link>
                                        <button type="submit" className="btn btn-submit">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
